export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/mariaB.1bfc5075.svg","height":19,"width":69,"blurWidth":0,"blurHeight":0};